import React, {FC} from 'react';

import {AsyncHandlerOf, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {compareName} from '../../../../srcCommon/helpers/localeHelpers';
import {CardAttributeUpdateAction} from '../../../helpers/models/cardAttributeUpdateHelpers';
import {TeammateModel} from '../../../models/api/teammateModel';
import {CustomAttributeModel} from '../../accounts/accountDetails/accountInformation/accountCustomAttribute';
import {CustomAttribute} from './customAttribute';

/*
 * Types.
 */

interface CustomAttributesSectionProps {
  customAttributes: ReadonlyArray<CustomAttributeModel>;
  teammates: ReadonlyArray<TeammateModel>;
  updateCardAttributeAsync: AsyncHandlerOf<CardAttributeUpdateAction>;
  updateUnsavedCard: HandlerOf<CardAttributeUpdateAction>;
}

/*
 * Component.
 */

export const CustomAttributesSection: FC<CustomAttributesSectionProps> = (props) => {
  const {customAttributes, teammates, updateCardAttributeAsync, updateUnsavedCard} = props;

  return (
    <>
      {sortCustomAttributes(customAttributes).map((customAttribute) => (
        <CustomAttribute
          key={customAttribute.customField.id}
          customAttribute={customAttribute}
          teammates={teammates}
          updateCardAttributeAsync={updateCardAttributeAsync}
          updateUnsavedCard={updateUnsavedCard}
        />
      ))}
    </>
  );
};

/*
 * Helpers.
 */

function sortCustomAttributes(customAttributes: ReadonlyArray<CustomAttributeModel>) {
  // Using slice to make a copy since the parameter is readonly
  return customAttributes.slice().sort((customAttribute1, customAttribute2) => {
    // Put empty values (newly-added attributes that haven't been saved) at the end
    if (customAttribute1.value === '') {
      return 1;
    }
    if (customAttribute2.value === '') {
      return -1;
    }

    return compareName(customAttribute1.customField.name, customAttribute2.customField.name);
  });
}
